export { Exclamation as default } from './Exclamation';
